module.exports = __webpack_public_path__ + "fonts/sourcesanspro-regular-webfont.2a78d9af.woff";